import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserLight } from '../models/userLight';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  postLoginRedirect : string;
  hasRedirect : boolean;
  constructor(private http : HttpClient) { 
  }

  fetchUsers() : Observable<Array<UserLight>>{
    let token = localStorage.getItem('STP-JWT');
    let headers = new HttpHeaders({
      "Authorization" : `Bearer ${token}`
    });
    return this.http.get<Array<UserLight>>(environment.baseURl + `/api/user`,{headers});
  }
}
